import React, { useState } from "react";
import "./ShapeSorter.css";

const shapes = [
  { name: "Circle", style: { borderRadius: "50%", backgroundColor: "red", width: "70px", height: "70px" } },
  { name: "Square", style: { backgroundColor: "blue", width: "70px", height: "70px" } },
  { name: "Triangle", style: { 
      width: 0, 
      height: 0, 
      borderLeft: "35px solid transparent", 
      borderRight: "35px solid transparent", 
      borderBottom: "70px solid green" 
    } 
  },
  { name: "Star", style: { fontSize: "50px", color: "gold" }, content: "⭐" },
  { name: "Heart", style: { fontSize: "50px", color: "pink" }, content: "❤️" },
  { name: "Hexagon", style: { 
      width: "70px", 
      height: "40px", 
      backgroundColor: "purple", 
      position: "relative" 
    } 
  }
];

export default function ShapeSorter() {
  const [draggedShape, setDraggedShape] = useState(null);
  const [score, setScore] = useState(0);
  const [message, setMessage] = useState("");

  // Load sounds
  const correctSound = new Audio("/sounds/correct.mp3");
  const wrongSound = new Audio("/sounds/wrong.wav");
  const winSound = new Audio("/sounds/win.mp3");

  const handleDragStart = (shape) => {
    setDraggedShape(shape);
  };

  const handleDrop = (target) => {
    if (draggedShape && draggedShape.name === target.name) {
      setScore(score + 10);
      setMessage("✅ Correct!");
      correctSound.play();
      if (score + 10 >= 60) {
        setMessage("🎉 You win! Final Score: " + (score + 10));
        winSound.play();
      }
    } else {
      setScore(score - 5);
      setMessage("❌ Wrong, try again!");
      wrongSound.play();
    }
    setDraggedShape(null);
  };

  return (
    <div className="shape-container">
      <h1>🔷 Shape Sorter Game</h1>
      <p>⭐ Score: {score}</p>
      <p className="status">{message}</p>
      <div className="drag-area">
        {shapes.map((shape, index) => (
          <div
            key={index}
            draggable
            onDragStart={() => handleDragStart(shape)}
            className="shape"
            style={shape.style}
          >
            {shape.content ? shape.content : ""}
          </div>
        ))}
      </div>
      <div className="drop-area">
        {shapes.map((shape, index) => (
          <div
            key={index}
            className="outline"
            onDragOver={(e) => e.preventDefault()}
            onDrop={() => handleDrop(shape)}
          >
            {shape.name}
          </div>
        ))}
      </div>
    </div>
  );
}

